module.exports = __webpack_public_path__ + "static/assets/91f2e12fe429965b5b219f289cf6aa31.png";